/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { useForm } from "react-hook-form";
import { ConfigContextUtils } from '../context/contextUtils.context';
import utils from '../utils/utils.functions';
import functions from '../views/facturacion/facturacion.functions';
import notification from './notification.component';

const AnularGuia = ({ codigo, show, onClose, title = '¿Seguro que desea anular esta venta?', onConfirm, isGuide}) => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const { register, handleSubmit, errors, reset } = useForm();
  const [proceso, setProceso] = useState(false);
  const onSubmit = data => {
    anularGuia(data);
  };

  useEffect(() => {
    reset({
      boletaId: codigo,
    });
  },[show]);

  const anularGuia = (data) => {
    setPreloader(true);
    functions.anular(data).then((response) => {
      if (response.boleta_error) {
        notification.warning(response.message);
      } else {
        notification.success(response.message);
        onConfirm();
      }
      setPreloader(false);
    });
  }


  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grupo-input mb-2">
        <h4>{title}</h4>
        <div className="d-flex flex-column">
           <textarea type="text"
              className={`form-control input-border ${errors.motivo_anulacion && "is-invalid"}`}
              name="motivo_anulacion"
              ref={register({ required: true })}
              disabled={proceso}
              placeholder="Cual es el motivo de la anulación"
            />
           {isGuide ? 
            <div className="alert-anular">
              <b>Importante! </b> Esta venta contiene una guía, al momento de anularla se anula la venta junto con la guía asociada.
            </div>
           :null}
           <input type="hidden" name="boletaId" ref={register({ required: true })}/>
           <div className="d-flex flex-row justify-content-between">
            <button type="button" className="btnx btnx-warn mt-2" onClick={() => onClose()}>Cancelar</button>
            <button type="submit" className="btnx btnx-warn mt-2" disabled={proceso}>Confirmar</button>
           </div>
        </div>
      </div>
      </form>
    </div>
  )
}

export default AnularGuia;